import { getContentForRichtextCell } from '~shared/types/Cell'

import { useCellSnapshot } from '@/features/rundown/data/cells.store'

import { RichtextPreviewRenderer } from './RichtextPreviewRenderer'

/**
 * Render static preview of cell content.
 */
export function RichtextColumnCellOutput({
  style,
}: {
  style: React.CSSProperties
}) {
  const cell = useCellSnapshot()

  const cellContentAsHTML = getContentForRichtextCell(cell?.content)

  return (
    <div
      className="rounded-sm overflow-hidden"
      style={style}
    >
      <RichtextPreviewRenderer contentAsHTML={cellContentAsHTML} />
    </div>
  )
}
